import { render, staticRenderFns } from "./lawsRegulations.vue?vue&type=template&id=cc62719e&scoped=true&"
import script from "./lawsRegulations.vue?vue&type=script&lang=js&"
export * from "./lawsRegulations.vue?vue&type=script&lang=js&"
import style0 from "./lawsRegulations.vue?vue&type=style&index=0&id=cc62719e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc62719e",
  null
  
)

export default component.exports